module.exports = __webpack_public_path__ + "media/images/tigor/tigor1-25ff050a5614cb6c684d9bc69f27e131.png";